import styled from "styled-components";
import { Table } from "antd";
import { COLORS } from "../../layout/theme";

export const AntdTable = styled(Table)`
	.ant-table-thead > tr > th {
		background: ${COLORS.Primary};
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${COLORS.White};

		div {
			color: ${COLORS.White};
		}
	}

	thead {
		border-color: ${COLORS.White};
		border: 1px solid ${COLORS.White};
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: flex-start;
`;
